"use client";

type StatusType = "connected" | "syncing" | "reconnecting" | "disconnected" | "editing";

interface StatusDotProps {
  status: StatusType;
  size?: "sm" | "md" | "lg";
  pulse?: boolean;
  className?: string;
}

const statusColors: Record<StatusType, string> = {
  connected: "bg-green-500",
  syncing: "bg-yellow-500",
  reconnecting: "bg-orange-500",
  disconnected: "bg-red-500",
  editing: "bg-blue-500",
};

const sizeStyles: Record<"sm" | "md" | "lg", string> = {
  sm: "w-1.5 h-1.5",
  md: "w-2 h-2",
  lg: "w-3 h-3",
};

export function StatusDot({
  status,
  size = "md",
  pulse = false,
  className = "",
}: StatusDotProps) {
  return (
    <span
      className={`
        inline-block rounded-full
        ${statusColors[status]}
        ${sizeStyles[size]}
        ${pulse ? "animate-pulse" : ""}
        ${className}
      `}
    />
  );
}

export { type StatusDotProps, type StatusType };
